<template>

	<div class="basic_wrap" style="overflow: hidden;">
		<div class="red_top_bg">
            <div class="back_left" @click="$router.back()"></div>
            <div class="big_tit">{{$t('shopds.help')}}</div>
        </div>
		<div class="wrap_box">
			<router-link :to="'about/' + v.id" class="item" v-for="(v,k) in data.list" :key="k">
				<div  class="van-col">
					<img :src="app?.logo_img" alt="">
				</div>
				<div class="van-col">
					<div>{{v['title_'+lang]}}</div>
					<div>{{v['time']}}</div>
				</div>
			</router-link>
		</div>
	</div>
</template>

<script>
	import Fetch from '../../utils/fetch';
	import bsHeader from '../../components/bsHeader.vue'
	export default {
		name: "login",
		components: {
			bsHeader
		},
		data() {
			return {
				lang:this.$i18n.locale||"zh_cn",
				show_icon_type: 'about',
				app: null,
				data: {},
			};
		},
		created() {
			this.$parent.footer('user',false);
		},
		mounted() {
			this.start();
		},
		methods: {
			start() {
				Fetch('/index/webconfig').then((r)=>{
					this.app = r.data;
				});
				Fetch('/index/about').then((r) => {
					this.data = r.data;
				});
				
			},
		}
	};
</script>

<style lang="less" scoped>
   
	
	.wrap_box{
		margin: 10px;
		margin-top: 10px;
		display: flex;
		flex-direction: column;
		align-items: center;
		.item{
			width: 95%;
			padding-top: 6px;
			border-bottom: 1px solid #ececec;
			font-size: 14px;
			color: rgba(0, 0, 0, 0.8);
			font-weight: 700;
			line-height: 20px;
			display: flex;
			justify-content: start;
		}
	}
	.van-col{
		text-align: left;
		
		div{
			color: #323232;
			font-size: 14px;
			line-height: 25px;
			height: 25px;
		}
		div:first-child{
			margin-top: 5px;
		}
		div:last-child{
			color: #909399;
			font-size: 12px;
		}
	}
	.van-col:first-child{
		img{
			width: 50px;
			height: 50px;
			margin:5px 15px;
		}
	}
</style>
